import React from "react";
// import { Link } from "react-router-dom";
import Newsletter from "../../Components/Newsletter/Newsletter";
import { Link } from "react-router-dom";
// import "./section.css";

export default function ServicePage() {
  return (
    <>
      <div
        className=" justify-center text-center pt-80 w-full h-screen bg-no-repeat bg-cover bg-fixed  md:w-32 lg:w-48	"
        Style="background-image: url('./image/9.jpg')"
      >
        <Link to="/contact">
          <button className="btn btn-success border-none  font-semibold bg-[#ee2da4]  rounded-none uppercase text-xs py-2 px-4">Get Started</button>
        </Link>

      </div>
      <div
        className=" justify-center text-center pt-80  w-full h-screen bg-no-repeat bg-cover bg-fixed	"
        Style="background-image: url('./image/10.jpg')"
      >
        <Link to="/contact">
          <button className="btn btn-success border-none  font-semibold bg-[#ee2da4]  rounded-none uppercase text-xs py-2 px-4">Get Started</button>
        </Link>
      </div>
      <div
        className=" justify-center text-center pt-80 w-full h-screen bg-no-repeat bg-cover bg-fixed	"
        Style="background-image: url('./image/full1.jpg')"
      >
 
      </div>
      <div
        className=" justify-center text-center pt-80 w-full h-screen bg-no-repeat bg-cover bg-fixed	"
        Style="background-image: url('./image/5.jpg')"
      >
        <Link to="/contact">
          <button className="btn btn-success border-none  font-semibold bg-[#ee2da4]  rounded-none uppercase text-xs py-2 px-4">Get Started</button>
        </Link>
      </div>
      <div
        className=" justify-center text-center pt-80 w-full h-screen bg-no-repeat bg-cover bg-fixed	"
        Style="background-image: url('./image/11.jpg')"
      >
        <Link to="/contact">
          <button className="btn btn-success border-none  font-semibold bg-[#ee2da4]  rounded-none uppercase text-xs py-2 px-4">Get Started</button>
        </Link>
      </div>
      <div
        className=" justify-center text-center pt-80 w-full h-screen bg-no-repeat bg-cover bg-fixed	"
        Style="background-image: url('./image/12.jpg')"
      >
        <Link to="/contact">
          <button className="btn btn-success border-none  font-semibold bg-[#ee2da4]  rounded-none uppercase text-xs py-2 px-4">Get Started</button>
        </Link>
      </div>
      <div
        className=" justify-center text-center pt-80 w-full h-screen bg-no-repeat bg-cover bg-fixed	"
        Style="background-image: url('./image/14.jpg')"
      >

      </div>
      <div
        className=" justify-center text-center pt-80 w-full h-screen bg-no-repeat bg-cover bg-fixed	"
        Style="background-image: url('./image/13.jpg')"
      >

      </div>
      <Newsletter />
    </>
  );
}
